/**
 * DOM Utilities
 */
export default class du {
    // @param  {Node} `el` The base element
    // @param {Object} `attrs` The key/value list of attributes
    // @return {Node} `el`
    // @usage du.setAttrs(el, {'role' : 'tab', 'tabindextab' : '0', ...});
    // Setting multiple attributes to an element
    static setAttrs(el, attrs) {
        var key;

        if (isElement(el) && isObject(attrs)) {
            for (key in attrs) {
                if (attrs.hasOwnProperty(key)) {
                    el.setAttribute(key, attrs[key]);
                }
            }
        } else {
            console.log('Error "' + el + '" should be a DOM element!!');
            console.log('Error "' + attrs + '" should be an Object!!');
        }
    }

    // addEventListener fallback for IE 8 lte
    static onEvent(el, eventName, handler) {
        if (window.addEventListener) {
            el.addEventListener(eventName, handler, false);
        } else {
            el.attachEvent('on' + eventName, function() {
                handler.call(el);
            });
        }
    }

    /**
     * addEventListener fallback for IE 8 lte with multi events support
     * @param {HTMLElement} el Required. Element watched by the function.
     * @param {String} eventsName Required. A String that specifies the names of the events separated by ' '.
     * @param {function} handler Required. Specifies the function to run when the event occurs.
     */
    static onEvents(el = null, eventsName = null, handler = null) {
        if (!el || !eventsName || !handler) {
            return;
        }
        if (el.nodeType === 1) {
            eventsName.split(' ').forEach(eventName => {
                if (window.addEventListener) {
                    el.addEventListener(eventName, handler, false);
                } else {
                    el.attachEvent('on' + eventName, function () {
                        handler.call(el);
                    });
                }
            });
        }
    }


    // addEventListener on NodeList
    // var some_nodes = document.querySelectorAll('.noeuds');
    // onEventNL(some_nodes, 'click', doSomethingFunction);
    static onEventNL(nlist, event, fn) {
        var lengthOf = nlist.length;

        while (lengthOf--) {
            onEvent(nlist[lengthOf], event, fn);
        }
    }

    // Array.indexOf for IE 8 gte
    static getIndex(array, item) {
        var lengthOf = array.length;

        while (lengthOf--) {
            if (array[lengthOf] === item) {
                return lengthOf;
            }
        }

        return -1;
    }

    // GetHeight
    // Get the largest measurement height
    static getHeight(el) {
        return  Math.max(el.scrollHeight, el.offsetHeight, el.clientHeight);
    }

    // setClass
    // Add a class to an element
    static setClass(el, classname) {
        if (el.classList) {
            el.classList.add(classname);
        } else {
            el.className += ' ' + classname;
        }
    }

    // @param  {Node} `el` The base element
    // @return {Number} The outerHeight(true) of the `el` element.
    static outerHeight(el) {
        var height = el.offsetHeight,
        style = getComputedStyle(el),
        marginTop = parseInt(style.marginTop) || 0,
        marginBottom = parseInt(style.marginBottom) || 0;

        height += marginTop + marginBottom;
        return height;
    };

    /**
     * return the max outerHeight from an element
     * @param  {String} cssClass
     * @param {HTMLElement} context NodeList
     * @return {int}    max height
     */
    static returnMaxOuterHeight(cssClass, parent = document) {
        var max = 0;
        var tmp = 0;
        du.queryAll(cssClass, parent).forEach((item) => {
            if ((tmp = du.outerHeight(item)) > max) {
                max = tmp;
            }
        });
        return (max);
    }

    // unsetClass
    // Remove a class from an element
    static unsetClass(el, classname) {
        if (el.classList) {
            el.classList.remove(classname);
        } else {
            el.className = el.className.replace(new RegExp('(^|\\b)'
                + classname.split(' ').join('|')
                + '(\\b|$)', 'gi'), ' ');
        }
    }

    /**
     * hasClass
     * Return true if an element has a specific class
     * @static
     * @param {HTMLElement} el
     * @param {String} classname
     * @returns true if an element has a specific class
     *
     * @memberOf du
     */
    static hasClass(el, classname) {
        if (el.classList) {
            return el.classList.contains(classname);
        } else {
            return new RegExp('(^| )' + classname + '( |$)', 'gi').test(el.className);
        }
    }

    /**
     * toggleClass
     * Toggle a class true if an element has a specific class
     * @static
     * @param {HTMLElement} el
     * @param {String} classname
     * @returns
     *
     * @memberOf du
     */
    static toggleClass(el, classname) {
        if (du.hasClass(el, classname)) {
            unsetClass(el, classname);
        } else {
            setClass(el, classname);
        }

        return;
    };

    // setDebounce
    // Source : <http://www.grafikart.fr/tutoriels/javascript/debounce-throttle-642>
    // Usage : search.addEventListener('keyup', du.setDebounce(function(e) {...}, 350))
    static setDebounce(callback, delay = 100) {
        var timer;

        return function() {
            var args = arguments;
            var context = this;

            clearTimeout(timer);

            timer = setTimeout(function() {
                callback.apply(context, args);
            }, delay);
        };
    }

    // setThrottle
    // Source : <http://www.grafikart.fr/tutoriels/javascript/debounce-throttle-642>
    // Usage : window.addEventListener('scroll', du.setThrottle(function(e) {...}, 50))
    static setThrottle(callback, delay = 100) {
        var last;
        var timer;

        return function() {
            var context = this;
            var now = +new Date();
            var args = arguments;

            if (last && now < last + delay) {
                clearTimeout(timer);

                timer = setTimeout(function() {
                    last = now;
                    callback.apply(context, args);
                }, delay);

            } else {
                last = now;
                callback.apply(context, args);
            }
        };
    }

    // slideDown
    // Usage : du.slideDown($panel);
    static slideDown(el) {
        var elMaxHeight = 0;

        if (el.getAttribute('data-maxheight')) {
            // we've already used this before, so everything is setup
            if (el.style.maxHeight.replace('px', '').replace('%', '') === '0') {
                el.style.maxHeight = el.getAttribute('data-maxheight');
            }

        } else {
            elMaxHeight = getHeight(el) + 'px';
            el.style['transition'] = 'max-height 0.25s ease-in-out, opacity 0.25s ease-in-out';
            el.style.overflowY = 'hidden';
            el.style.maxHeight = '0';
            el.setAttribute('data-maxheight', elMaxHeight);
            el.style.display = 'block';

            // we use setTimeout to modify maxHeight later than display (to we have the transition effect)
            setTimeout(function() {
                el.style.maxHeight = elMaxHeight;
            }, 10);
        }

        el.style.opacity = '1';
    }

    // slideUp
    // Usage : du.slideUp($panel);
    static slideUp(el) {
        if (el.getAttribute('data-maxheight')) {
            // we've already used this before, so everything is setup
            if (el.style.maxHeight.replace('px', '').replace('%', '') !== '0') {
                el.style.maxHeight = '0';
            }
        }

        el.style.opacity = '0';
    }

    // Is a given value a DOM element?
    static isElement(obj) {
        return !!(obj && obj.nodeType === 1);
    }

    // Is a given variable an object?
    static isObject(obj) {
        var type = typeof obj;

        return type === 'function' || type === 'object' && !!obj;
    }

    /**
     * Merge defaults with user options
     *
     * @param {Object} defaults Default settings
     * @param {Object} options User options
     * @returns {Object} Merged values of defaults and options
     */
    static extend( defaults, options ) {
        let extended = {};
        let prop;
        for (prop in defaults) {
            if (Object.prototype.hasOwnProperty.call(defaults, prop)) {
                extended[prop] = defaults[prop];
            }
        }
        for (prop in options) {
            if (Object.prototype.hasOwnProperty.call(options, prop)) {
                extended[prop] = options[prop];
            }
        }
        return extended;
    }

    // Usage : triggerEvent(element, 'mousedown');
    static triggerEvent(el, type) {
        var e;

        if ('createEvent' in document) {
            // modern browsers, IE9+
            e = document.createEvent('HTMLEvents');

            e.initEvent(type, true, false);
            el.dispatchEvent(e);
            //console.log(e);
        } else {
            // IE 8
            e = document.createEventObject();

            e.eventType = type;
            el.fireEvent('on' + e.eventType, e);
        }
    }

    /**
     * Query nodes from a selector and return an Array of nodes
     *
     *      du.queryAll('.main');
     *      du.queryAll('.block', parentNode);
     *
     * @param {String} expr Selector to query on the dom
     * @param {HTMLElement} container An optional parent Node from the query
     * @return {HTMLElement[]} Nodes Array of queryed nodes
     */
    static queryAll(expr, container) {
        return Array.prototype.slice.call((container || document).querySelectorAll(expr));
    }

    /**
     * Toggle html attribute boolean string
     *
     *      du.toggleAttribute(node, 'aria-expanded');
     *
     * @param {HTMLElement} The node to apply toggling
     * @param {String} The html attribute name
     * @return {String} The new attribute string
     */
    static toggleAttribute(node, attribute) {
        let oldvalue = this.parseBoolean(node.getAttribute(attribute));
        let newValue = !oldvalue + '';
        node.setAttribute(attribute, newValue);
        return newValue;
    }

    /**
     * Parse string to boolean
     *
     *      du.parseBoolean('true');
     *      du.parseBoolean('false');
     *
     * @param {String} The string to parse
     * @return {Boolean} The converted boolean
     */
    static parseBoolean(attribute) {
        return 'true' === attribute;
    }

    /* eslint-disable max-statements, max-depth */
    /**
     * Get closest DOM element up the tree that contains a class, ID, data attribute, or tag.
     * Includes the element itself. Supported back to IE6.
     * Source : http://gomakethings.com/ditching-jquery#climb-up-the-dom
     * @static
     * @param {HTMLElement} elem
     * @param {String} selector
     * @returns HTMLElement or null
     *
     * @memberOf du
     */
    static getClosest(elem, selector) {
        // Variables
        var firstChar = selector.charAt(0);
        var supports = 'classList' in document.documentElement;
        var attribute, value;
        // If selector is a data attribute, split attribute from value
        if ( firstChar === '[' ) {
            selector = selector.substr( 1, selector.length - 2 );
            attribute = selector.split( '=' );
            if ( attribute.length > 1 ) {
                value = true;
                attribute[1] = attribute[1].replace( /"/g, '' ).replace( /'/g, '' );
            }
        }
        // Get closest match
        for ( ; elem && elem !== document && elem.nodeType === 1; elem = elem.parentNode ) {
            // If selector is a class
            if ( firstChar === '.' ) {
                if ( supports ) {
                    if ( elem.classList.contains( selector.substr(1) ) ) {
                        return elem;
                    }
                } else {
                    if ( new RegExp('(^|\\s)' + selector.substr(1) + '(\\s|$)').test( elem.className ) ) {
                        return elem;
                    }
                }
            }
            // If selector is an ID
            if ( firstChar === '#' ) {
                if ( elem.id === selector.substr(1) ) {
                    return elem;
                }
            }
            // If selector is a data attribute
            if ( firstChar === '[' ) {
                if ( elem.hasAttribute( attribute[0] ) ) {
                    if ( value ) {
                        if ( elem.getAttribute( attribute[0] ) === attribute[1] ) {
                            return elem;
                        }
                    } else {
                        return elem;
                    }
                }
            }
            // If selector is a tag
            if ( elem.tagName.toLowerCase() === selector ) {
                return elem;
            }
        }
        return null;
    }
    /* eslint-enable max-statements, max-depth */

    /**
     *  take a list of elements and add class on touchstart event on each element
     * @param {HTMLElement} elems - a list of elements.
     * @param {String} cssClass - the added css class
     */
    static hoverOnScrollForMobile(elems, cssClass) {
        elems.forEach( elem => {
            du.onEvent(elem, 'touchstart', () => {
                elem.classList.add(cssClass);
            });

            du.onEvent(elem, 'touchend', () => {
                elem.classList.remove(cssClass);
            });
        });
    }

};



// WEBPACK FOOTER //
// ./src/main/js/utils/dom-utilities.js